<ng-container *ngFor="let star of stars">
    <img *ngIf="star === 'full'" src="assets/images/all-img/fillStar.svg" alt="Full Star" class="star-icon" />
    <img *ngIf="star === 'half'" src="assets/images/all-img/halfStar.svg" alt="Half Star" class="star-icon" />
    <img *ngIf="star === 'empty'"  src="assets/images/all-img/emptyStar.svg" alt="Empty Star" class="user-star-icon">
</ng-container>
